<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="4">
        <div class="mobile-image-wrapper">
          <v-row class="image-width" align="center" justify="center">
            <v-img
              v-if="settings.logo_mob_header"
              :src="getImageUrl(settings.logo_mob_header)"
              contain
              class="image-preview"
            >
              <v-row justify="center" align="center" class="position-relative fill-height">
                <primary-button color="error" @click="$emit('select-image', 'logo_mob_header')">
                  {{ $t("banner_header") }}
                </primary-button>
                <remove-button
                  style="position: absolute; top: 85px"
                  @click="$emit('remove-image', 'logo_mob_header')"
                />
              </v-row>
            </v-img>
            <v-btn
              v-else
              class="ma-2"
              outlined
              color="primary"
              small
              @click="$emit('select-image', 'logo_mob_header')"
            >
              {{ $t("banner_header") }}
            </v-btn>
          </v-row>
        </div>
        <div class="mobile-input-wrapper">
          <text-field
            :label="$t('header_banner_link')"
            v-model="settings.mob.baner_link_header"
            class="mobile-link-field"
          />
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="mobile-image-wrapper">
          <v-row class="image-width" align="center" justify="center">
            <v-img
              v-if="settings.logo_mob_footer"
              :src="getImageUrl(settings.logo_mob_footer)"
              contain
              class="image-preview"
            >
              <v-row justify="center" align="center" class="fill-height">
                <primary-button color="error" @click="$emit('select-image', 'logo_mob_footer')">
                  {{ $t("banner_footer") }}
                </primary-button>
                <remove-button
                  style="position: absolute; top: 85px"
                  @click="$emit('remove-image', 'logo_mob_footer')"
                />
              </v-row>
            </v-img>
            <v-btn
              v-else
              class="ma-2"
              outlined
              color="primary"
              small
              @click="$emit('select-image', 'logo_mob_footer')"
            >
              {{ $t("banner_footer") }}
            </v-btn>
          </v-row>
        </div>
        <div class="mobile-input-wrapper">
          <text-field
            :label="$t('footer_banner_link')"
            v-model="settings.mob.baner_link_footer"
            class="mobile-link-field"
          />
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="mobile-image-wrapper">
          <v-row class="image-width" align="center" justify="center">
            <v-img
              v-if="settings.logo_mob_restoran"
              :src="getImageUrl(settings.logo_mob_restoran)"
              contain
              class="image-preview"
            >
              <v-row justify="center" align="center" class="fill-height">
                <primary-button
                  color="error"
                  @click="$emit('select-image', 'logo_mob_restoran')"
                >
                  {{ $t("restaurant") }}
                </primary-button>
                <remove-button
                  style="position: absolute; top: 85px"
                  @click="$emit('remove-image', 'logo_mob_restoran')"
                />
              </v-row>
            </v-img>
            <v-btn
              v-else
              title="Slika u listi restorana"
              class="ma-2"
              outlined
              color="primary"
              small
              @click="$emit('select-image', 'logo_mob_restoran')"
            >
              {{ $t("restaurant") }}
            </v-btn>
          </v-row>
        </div>
        <div class="mobile-input-wrapper">
          <text-field
            :label="$t('restaurant_banner_link')"
            v-model="settings.mob.baner_link_restoran"
            class="mobile-link-field"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import conf from "@/config";

export default {
  name: "MobileAppDesignSection",
  props: {
    settings: {
      type: Object,
      required: true,
    },
    restaurantId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      conf: conf,
    };
  },
  methods: {
    getImageUrl(imageName) {
      if (!imageName) return "";
      return `${this.conf.apiUrlBase}/gallery/${this.restaurantId}/medium/${imageName}`;
    },
  },
};
</script>

<style scoped>
.image-width {
  width: 100%;
  max-width: 280px;
  height: 140px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;
}

.image-preview {
  max-width: 100%;
  max-height: 100%;
}

.mobile-image-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 12px;
}

.mobile-input-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.mobile-link-field {
  width: 100%;
  max-width: 280px;
}
</style>
